import * as React from "react"
import { Column } from "@tanstack/react-table"
import { ArrowUpDown, ArrowUpZA, ChevronDown, ChevronUp, ChevronsUpDown } from "lucide-react"

interface SortableHeaderProps<T> {
  column: Column<T, unknown>
  title: string
  className?: string
  defaultSort?: 'asc' | 'desc'
}

export function SortableHeader<T>({
  column,
  title,
  className = '',
  defaultSort
}: SortableHeaderProps<T>) {

  React.useEffect(() => {
    if (defaultSort && !column.getIsSorted()) {
      column.toggleSorting(defaultSort === 'desc');
    }
  }, [column, defaultSort]);

  return (
    <div
      className={`flex items-center space-x-2 cursor-pointer hover:text-blue-600 ${className}`}
      onClick={() => column.toggleSorting()}
    >
      <span>{title}</span>
      {column.getIsSorted() === "asc" ? (
        <ChevronDown className="h-4 w-4" />
      ) : column.getIsSorted() === "desc" ? (
        <ChevronUp className="h-4 w-4" />
      ) : (
        <ChevronsUpDown className="h-4 w-4 text-gray-400" />
      )}
    </div>
  )
}
